import { render, staticRenderFns } from "./NotificationAssigned.vue?vue&type=template&id=75cd3e57&scoped=true&lang=pug&"
import script from "./NotificationAssigned.vue?vue&type=script&lang=js&"
export * from "./NotificationAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd3e57",
  null
  
)

export default component.exports